import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./RegisterBox.css";
const connectBg = "https://storage.googleapis.com/rasai-nutrie-assets/videos/connect-bg.mp4";

const RegisterBox = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const handleRegister = () => {
    if (email.trim()) {
      navigate("/register", { state: { email } });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleRegister();
    }
  };

  return (
    <section className="register-section">
      <video
        className="register-video-bg"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={connectBg} type="video/mp4" />
      </video>

      <div className="register-box">
        {isAuthenticated ? (
          <>
            <h2>Welcome, {user?.full_name?.split(" ")[0]}!</h2>
            <p>Thank you for being part of the RASAI Nutrie community.</p>
            <p className="welcome-msg">Explore our products and enjoy your wellness journey.</p>
          </>
        ) : (
          <>
            <h2>Connect With Us!</h2>
            <p>Create an account to get personalized recommendations, track orders, and more.</p>
            <div className="register-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <button onClick={handleRegister}>Register</button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default RegisterBox;
